const INTENTS_CHAIN = "near";

export function getDepositChain(
	depositType: string | undefined,
	originAssetChain: string | undefined,
) {
	if (depositType === "INTENTS") {
		return INTENTS_CHAIN;
	}

	if (depositType === "ORIGIN_CHAIN") {
		return originAssetChain;
	}

	return undefined;
}

export function getRecipientChain(
	recipientType: string | undefined,
	destinationAssetChain: string | undefined,
) {
	if (recipientType === "INTENTS") {
		return INTENTS_CHAIN;
	}

	if (recipientType === "DESTINATION_CHAIN") {
		return destinationAssetChain;
	}

	return undefined;
}

export function getRefundChain(
	refundType: string | undefined,
	originAssetChain: string | undefined,
) {
	if (refundType === "INTENTS") {
		return INTENTS_CHAIN;
	}

	if (refundType === "ORIGIN_CHAIN") {
		return originAssetChain;
	}

	return undefined;
}
